import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'save-delete-buttons',
  templateUrl: './save-delete-buttons.component.html',
  styleUrls: ['./save-delete-buttons.component.scss'],
})
export class SaveDeleteButtonsComponent implements OnInit {
  @Input() saveColor: string = 'success';
  @Input() deleteColor: string = 'danger';
  @Input() saveLabel: string;
  @Input() deleteLabel: string;
  @Input() showDelete: boolean = false;
  @Input() disableSave: boolean = false;

  @Output() onDelete: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSave: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  emit(type: string) {
    if (type === 'delete') {
      this.onDelete.emit();
    } else {
      this.onSave.emit();
    }
  }
}
